module.exports = __webpack_public_path__ + "src/assets/games/33/wheel063.jpg";